<div class="modal-body p-3 p-md-4">

  <div class="d-flex align-items-start justify-content-between mb-3">
    <div class="overflow-hidden">
      <p class="fs-normal fw-800 color-gray-950 mb-0">{{'planner.move_another_week'|translate}}</p>
      <p class="fs-small fw-400 color-gray-400 mb-0 text-truncate">{{itemTitle()}}</p>
    </div>

    <a class="clickable color-gray-400 ms-2" (click)="modal.dismiss()" [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
  </div>

  <div class="row g-2">
    <div class="col-6 col-md-4" *ngFor="let week of weeks">
      <a class="week-option d-block text-center fs-small fw-800 p-2 clickable" (click)="modal.close(week.id)">
        {{'planner.week_number'|translate: {week: week.weekNumber} }}
      </a>
    </div>
  </div>

  <p class="fs-small fw-400 color-gray-400 mb-0 mt-3" *ngIf="!weeks.length">
    {{'planner.no_other_week'|translate}}
  </p>

</div>
